import React from "react";
import { useVitalsSubdomainRedirect } from "../../hooks/useVitalsSubdomainRedirect";

const VitalsRedirectHandler: React.FC = () => {
  // Hook handles all redirect logic internally
  useVitalsSubdomainRedirect();

  // No UI needed - redirect logic is handled by the hook
  return null;
};

export default VitalsRedirectHandler;
